import React, { useEffect, useState } from 'react'
import { Grid, IconButton } from '@mui/material'
import { SwapIcon } from '../../svgIcons/SwapIcon'
import TokenSelectorNew from '../TokenSelectorNew/TokenSelectorNew'
import { useStoreState } from '../../model/hooks'
import { isSufficientBalanceInWallet } from '../../model/tokens/helper'

function SwapCard(props: {
    network: string
    token2Amount: string
    token2: string
    token1Amount: string
    handleTokenAmountChange: any
    handleToken2Select: any
    switchTokensAndAmounts: any
    handleToken1Select: any
    token1: string
    isSelect1Disabled?: boolean
    isSelect2Disabled?: boolean
    setIsMaxBalance: (isMax: boolean) => void
}) {
    const {
        network,
        token2Amount,
        token2,
        token1Amount,
        handleTokenAmountChange,
        handleToken2Select,
        switchTokensAndAmounts,
        token1,
        handleToken1Select,
        isSelect1Disabled = false,
        isSelect2Disabled = false,
        setIsMaxBalance
    } = props
    const tokens = useStoreState((state) => (network ? state.tokens.tokens[network] : {}))
    const [isToken1Disabled, setIsToken1Disabled] = useState(true)
    const [isToken2Disabled, setIsToken2Disabled] = useState(true)

    useEffect(() => {
        if (token1) {
            setIsToken1Disabled(false)
        }
    }, [token1])

    useEffect(() => {
        if (token2) {
            setIsToken2Disabled(false)
        }
    }, [token2])

    return (
        <>
            <div
                className={`p-4 lg:px-4 mb-[-20px]`}
                style={{
                    background: isSufficientBalanceInWallet(network, token1, token1Amount) ? '#1D285A' : 'rgba(255, 83, 83, 0.2)',
                    borderRadius: '8px',
                    boxShadow: '0px 3px 7px rgba(28, 28, 34, 0.33)'
                }}>
                <div className='flex justify-between'>
                    <div className='flex flex-1'>
                        <TokenSelectorNew
                            setIsMaxBalance={(isMax) => setIsMaxBalance(isMax)}
                            isSelectDisabled={isSelect1Disabled}
                            error={isSufficientBalanceInWallet(network, token1, token1Amount) ? '' : 'Exceeds Balance'}
                            tokenAmount={token1Amount}
                            network={network}
                            token={token1}
                            tokenStr={'Token 1'}
                            otherToken={token2}
                            tokens={tokens ? Object.values(tokens) : []}
                            handleTokenSelect={handleToken1Select}
                            showMaxButton={true}
                            handleTokenAmountChange={handleTokenAmountChange}
                            inputs={
                                <div className='flex justify-center mb-4 flex-col w-full text-right text-[18px] lg:text-[24px] font-bold items-end'>
                                    <input
                                        className='bg-transparent text-right text-white outline-none w-full lg:max-w-auto'
                                        disabled={isToken1Disabled}
                                        placeholder='0.00'
                                        value={token1Amount}
                                        onChange={(e) => handleTokenAmountChange(token1, e.target.value)}
                                    />
                                </div>
                            }
                        />
                    </div>
                </div>
            </div>

            <Grid container direction='row' justifyContent='center' alignItems='center'>
                <IconButton size='small' disabled={!token1 && !token2} className='z-[10]' onClick={switchTokensAndAmounts}>
                    <div className='cursor-pointer flex items-center justify-center w-[36px] h-[36px] bg-[#1D285A] rounded-full p-2' style={{ border: '2px solid #0C3F6D' }}>
                        <SwapIcon className='text-white w-[20px] h-[20px]' />
                    </div>
                </IconButton>
            </Grid>

            <div className='bg-[#1D285A] p-4 lg:px-4 mt-[-20px]' style={{ borderRadius: '8px', boxShadow: '0px 3px 7px rgba(28, 28, 34, 0.33)' }}>
                <div className='flex'>
                    <div className='flex flex-1 mt-2 lg:mt-0'>
                        <TokenSelectorNew
                            error=''
                            setIsMaxBalance={(isMax) => setIsMaxBalance(isMax)}
                            isSelectDisabled={isSelect2Disabled}
                            network={network}
                            tokenAmount={token2Amount}
                            token={token2}
                            tokenStr={'Token 2'}
                            otherToken={token1}
                            tokens={tokens ? Object.values(tokens) : []}
                            handleTokenSelect={handleToken2Select}
                            showMaxButton={false}
                            handleTokenAmountChange={handleTokenAmountChange}
                            inputs={
                                <div className='flex justify-center mb-4 flex-col w-full text-right text-[18px] lg:text-[24px] font-bold items-end'>
                                    <input
                                        className='bg-transparent text-right text-white outline-none w-full lg:max-w-auto'
                                        disabled={isToken2Disabled}
                                        placeholder='0.00'
                                        value={token2Amount}
                                        onChange={(e) => handleTokenAmountChange(token2, e.target.value)}
                                    />
                                </div>
                            }
                        />
                    </div>
                </div>
            </div>
        </>
    )
}

export default SwapCard
